import { StandardAlert } from '@cimplico/components';
import { useState } from 'react';
import { printCsvFileErrorMessages } from '../../utilities/csv-file';

type CsvFileRowErrorProps = {
    title?: string;
    useRowAsIdentifier?: boolean;
    errorMessages: { [rowNumber: string]: string[] };
};

function CsvFileRowError({ title, useRowAsIdentifier = true, errorMessages }: CsvFileRowErrorProps): JSX.Element {
    const [viewErrors, setViewErrors] = useState(false);
    return (
        <div className="mb-4">
            <StandardAlert
                type="error"
                title={title || `There are errors in row ${Object.keys(errorMessages).join(', ')}`}
                description={viewErrors ? printCsvFileErrorMessages(errorMessages, useRowAsIdentifier) : undefined}
            >
                {!viewErrors && <StandardAlert.Button onClick={(): void => setViewErrors(!viewErrors)}>View more</StandardAlert.Button>}

                {viewErrors && <StandardAlert.Button onClick={(): void => setViewErrors(!viewErrors)}>View less</StandardAlert.Button>}
            </StandardAlert>
        </div>
    );
}

export default CsvFileRowError;
